// src/usercomponents/Cartcontainer/Cartcontainer.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './Cartcontainer.module.css';
import { FaTrash } from 'react-icons/fa';
import config from '../../config/config';
import { FiRefreshCw } from "react-icons/fi";
import { CartContext } from '../../context/Cartcontext';
import { useContext } from 'react';

const Cartcontainer = () => {
  const navigate = useNavigate();
  const { cartItems, fetchCart } = useContext(CartContext);

  const handleRemoveItem = async (productId) => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      await axios.delete(`${config.apiBaseUrl}/api/users/cart/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchCart(); // Refresh cart after removal
    } catch (error) {
      console.error('Failed to remove item:', error);
    }
  };

  return (
    <div className={styles.cartContainer}>
      <button className={styles.refreshButton} onClick={fetchCart}>
    Refresh
    <FiRefreshCw className={styles.refreshIcon}/>
  </button>
      {cartItems.length === 0 ? (
        <p className={styles.emptyCart}>Your cart is empty.</p>
      ) : (
        <div className={styles.cartGrid}>
          {cartItems.map(item => (
            <div key={item.productId} className={styles.cartCard}>
              <img
                src={item.images?.[0]?.url || 'https://via.placeholder.com/150'}
                alt={item.productName}
                className={styles.productImage}
                onClick={() => navigate(`/product/${item.productId}`)}
              />
              <div className={styles.productInfo}>
                <h3
                  className={styles.productName}
                  onClick={() => navigate(`/product/${item.productId}`)}
                >
                  {item.productName}
                </h3>
                <p className={styles.productPrice}>NPR {item.price}</p>
                <p className={styles.productQuantity}>Qty: {item.quantity || 1}</p>

                <div className={styles.cartButtons}>
                  <button
                    className={styles.buyNowButton}
                    onClick={() => navigate(`/buynow/${item.productId}`, { state: { product: item } })}
                  >
                    Buy Now
                  </button>
                  <button
                    className={styles.removeButton}
                    onClick={() => handleRemoveItem(item.productId)}
                    title="Remove item"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Cartcontainer;
